import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  snackbar: {
    maxWidth: '78vw',
    wordBreak: 'break-all',
  },
}));

export default useStyles;
